import Shoutout from './Shoutout';
export default Shoutout;